module.exports = __webpack_public_path__ + "img/vertical_6_1_8011.79cc48b7.png";